import styled from 'styled-components';

export const Wrapper = styled.div`
	max-width: 100vw;
	overflow: hidden;
	padding-top: 80px;
	@media screen and (max-width: 768px) {
		padding-top: 58px;
	}
`;
